export const INITIAL_STATE_KEY = '__EFFECTOR_NEXTJS_INITIAL_STATE__'
